import '.f8{max-width:560px;}.ssr-plugin'
import '.c0{padding:48px;}.ssr-plugin'
import '.fa{height:calc(100vh - 124px);}.ssr-plugin'
import '.ag{box-sizing:border-box;}.ssr-plugin'
import '.o{display:flex;}.ssr-plugin'
import '.p{flex-direction:column;}.ssr-plugin'
import '.bb{justify-content:center;}.ssr-plugin'
import '.cr{margin-bottom:24px;}.ssr-plugin'
import '.fg{font-size:14px;}.ssr-plugin'
import '.b6{margin-bottom:72px;}.ssr-plugin'
import '.di{cursor:pointer;}.ssr-plugin'
import '.fh{text-decoration:underline;}.ssr-plugin'
import { useLocation } from 'wouter'
import { styled } from 'inlines'
import { colors } from '../../utils/colors.js'
import { Button } from '../../components/Button.js'
import { Icon } from '../../assets/icons/index.js'
import { useTrack } from '../../hooks/useTrack.js'
import { AnalyticsEvent } from '../../../../shared/analyticsEvents.js'
import { useOnboarded } from '../../hooks/useOnboarded.js'
import { TABLET, MOBILE, HEIGHT } from '../../utils/breakpoints.js'
import { useClient } from '@based'
import { useSession } from '../../hooks/useSession.js'

export const StepFour = ({ dictionary, setPrivacyModal }) => {
  const client = useClient()
  const [, setSession] = useSession()
  const track = useTrack('onboarding')
  const [, setOnboarded] = useOnboarded()
  const [, setLocation] = useLocation()

  return (
    <styled.div className="f8 c0 fa ag o p bb"
      id="onboarding-step-four-content"
      style={{
        [TABLET]: {
          padding: '24px',
        },
        [MOBILE]: {
          height: 'calc(100dvh - 124px)',
          boxSizing: 'border-box',
          justifyContent: 'flex-end',
        },
      }}
    >
      <styled.div
        style={{
          [MOBILE]: {
            marginTop: '0px',
          },
        }}
      >
        <styled.h2 className="cr"
          style={{
            [HEIGHT]: {
              marginTop: '134px',
            },
          }}
        >
          {dictionary.trackingTitle}
        </styled.h2>
        <p className="cr fg">
          {dictionary.trackingEssentials}
        </p>
        <p className="cr fg">
          {dictionary.trackingAnalytics}
        </p>
        <styled.p className="fg b6"
          style={{
            [HEIGHT]: {
              marginBottom: '12px',
            },
          }}
        >
          <a className="di fh"
            onClick={() => setPrivacyModal(true)}
          >
            {dictionary.privacyPolicy}↗
          </a>
        </styled.p>
      </styled.div>

      <Button
        ariaLabel={dictionary.acceptEssentials}
        id="onboarding-step-four-action-accept-essential-cookies"
        trailIcon={<Icon type="forwardIcon" color={colors.white} />}
        fullWidth
        onClick={() => {
          track(AnalyticsEvent.ONBOARDING_CLICK, 'refuse-tracking')
          setOnboarded(true)
          setLocation('/')
        }}
        variant="border"
        style={{ marginBottom: 16, textAlign: 'left' }}
      >
        {dictionary.acceptEssentials}
      </Button>
      <Button
        ariaLabel={dictionary.acceptTracking}
        id="onboarding-step-four-action-accept-all-cookies"
        trailIcon={<Icon type="forwardIcon" color={colors.secondary} />}
        fullWidth
        onClick={() => {
          track(AnalyticsEvent.ONBOARDING_CLICK, 'accept-tracking')
          client
            .call('accept-tracking')
            .then((msg) => {
              if (msg && msg.signature && msg.session) {
                setSession(JSON.stringify(msg))
              }
            })
            .catch(() => {
              console.warn('failed to accept-tracking')
            })
          setOnboarded(true)
          setLocation('/')
        }}
        style={{ textAlign: 'left' }}
      >
        {dictionary.acceptTracking}
      </Button>
    </styled.div>
  )
}
